module.exports = __webpack_public_path__ + "img/14.ccfb6a28.jpg";